import React from 'react';

import { CoreIcon } from '@aspid/ui';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Box,
} from '@mui/material';

import { ActionButton, CancelButton } from '@components/buttons';
import { IconCollection } from '@components/icons/iconCollection';

import type { ActionModalProperties } from './ActionModal.types';

export const ActionModal: React.FC<ActionModalProperties> = ({
  dataTest = 'action_modal',
  content,
  showModal,
  title,
  onAccept,
  onRefuse,
  isLoading,
  acceptButtonDisabled,
  refuseButtonDisabled,
  acceptButtonLabel,
  refuseButtonLabel,
  acceptButtonColor = 'error',
  refuseButtonColor = 'primary',
  acceptButtonType = 'button',
  acceptButtonFormName,
  withHelp,
  onClickOnHelp,
}) => {
  return (
    <Dialog data-testid={dataTest} open={showModal} disableRestoreFocus>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
        <DialogTitle variant='h2'>{title}</DialogTitle>
        {withHelp && (
          <CoreIcon
            icon={IconCollection.questionCircle}
            sx={{ pr: 3, fontSize: '1.5rem' }}
            color='warning'
            onClick={onClickOnHelp}
          />
        )}
      </Box>
      <DialogContent sx={{ width: 600 }}>{content}</DialogContent>
      <DialogActions sx={{ mx: 2, mb: 2 }}>
        <CancelButton
          onClick={onRefuse}
          disabled={refuseButtonDisabled}
          label={refuseButtonLabel}
          color={refuseButtonColor}
        />
        <ActionButton
          onClick={onAccept}
          isSubmitting={isLoading}
          isDisabled={acceptButtonDisabled}
          label={acceptButtonLabel}
          color={acceptButtonColor}
          type={acceptButtonType}
          form={acceptButtonFormName}
        />
      </DialogActions>
    </Dialog>
  );
};
